<template>
  <div class="page" :style="{ '--styleColor': style.style_color}">
    <TipsHbrb ref="child"></TipsHbrb>
    <div class="topBanner titleDown">
      <img :src="style.bg_index" alt="">
    </div>
    <div class="btnBox">
      <div class="learn startTada" @click="toReg">
        <img :src="style.bg_start" alt="">
      </div>
      <!-- <div class="rule" @click="noticeBox">
        <img src="@/assets/images/learn/rule.png" alt="">
      </div> -->
      <!-- <div class="exam" @click="toExam">
        <img src="@/assets/images/learn/exam.png" alt="">
      </div> -->
    </div>
    <div class="note" @click="noticeBox">活动规则</div>

    <!-- 活动规则 -->
    <van-popup v-model="showNotice" closeable close-icon="close" position="bottom" round>          
      <div class="noticBox">        
        <h2 class="noticTitle">
          <span class="line"></span>
          <span class="text">活动规则</span>
          <span class="line"></span>
        </h2>
        <div class="noticTxt" v-html="explain">
          <!-- <p><strong>兑奖流程：</strong></p>
          <p>4月5日-20日，中奖者凭中奖时填写的姓名、电话，到景区售票处兑换当日门票。</p>
          <p><strong>活动须知：</strong></p>
          <p>每期活动，每个用户IP只有一次中奖机会，凭本人中奖时填写的信息兑换门票，他人不可代领。</p> -->
        </div>
      </div>
    </van-popup>

  
    <!-- <div class="navBox">
      <div class="navTxt" @click="toHome"><i class="iconfont icon-zhuye"></i>首页</div>
      <div class="navTxt" @click="toMyCenter"><i class="iconfont icon-wode1"></i>个人中心</div>
    </div> -->
  </div>
</template>

<script>

//纵览顶部提示栏及唤起app
import TipsHbrb from '@/components/TipsHbrb.vue'
import zonglan from '@/utils/cp-zonglan.js'
import {reqInit,reqExplain,reqIsReg} from '@/api/index.js'
import {reqLearnList} from '@/api/index2.js'
import Cookies from 'js-cookie'
import jump2zonglan from '@/utils/jump2app-zonglan.js'
//分享
import { wxShare } from '@/utils/wxshare-wes2.com.js'
import { Dialog } from 'vant';
export default {
  name: 'index',
  components: {
    TipsHbrb,
  },
  data () {
    return {
      learnid:0,
      actInfo:"",
      token:"",
      accountId:'',
      uniqueId:'',
      title:"",          
      showNotice:false,
      style:{},
      explain:"",
    }
  },  
  created (){
    
 
  },
  mounted () {
    let learnid = this.$route.query.learnid;
    if(learnid) {
      this.learnid = learnid;
      let accountId = this.$store.state.accountId;
      let uniqueId = this.$store.state.uniqueId;
      if(accountId && uniqueId){
        this.accountId = accountId;
        this.uniqueId = uniqueId;
      }else{
          if (process.env.NODE_ENV === 'development') {
              // 指定用户登录测试 begin
              // let accountId = '638d93556e322120621e0166';
              // let uniqueId = '672c85a705e822489b33842d';
              // this.accountId = accountId;
              // this.uniqueId = uniqueId;
              // this.$store.commit("SET_ACCOUNTID",accountId);
              // this.$store.commit("SET_UNIQUEID",uniqueId);    
              // 指定用户登录测试 end
          } else if (process.env.NODE_ENV === 'production') {
              // 生产环境
              console.log('production');
          }
          this.cpLoad(true)  //日报客户端js-sdk加载并初始化
      }
      
      this.actInit();  //加载活动信息

    }else{
      this.$toast({
        icon: 'warning-o',
        message: '活动不存在！'
      });
    }

  },  
  computed: {},
  methods: {
    login(){
      this.$refs.child.toLink()      
    },
    cpLoad(runAll) {
      let _this = this; 
      let cpMain = function() {
        
          let is_login = false;
          CP.getDeviceInfo({
              completed: function(data){
                  // data > {device_no:'',system:'',system_version:'',device_type:'',timestamp: '',signature：'', app: '', version: '', networkType: '', statusBarHeight: ''}
                  CP.tools.writelog('get_device_info', data);                   
                  console.log('hbrb_version',data.version);
              },
              cpIncompatible: function () {
                  CP.tools.writelog('CP.getDeviceInfo', '此环境不支持此方法');
              }
          });
          //自身的业务代码，以下为调用样例
          CP.isLogin({  //判断是否登录的接口，
            completed: function(data){
            CP.tools.writelog('get_is_login', data);			
            if(data.is_login==1) {
              is_login=true;					
              //获取unique_id
              CP.getUniqueId({
                completed: function(data){
                  console.log('data.unique_id',data.unique_id);
                  _this.$store.commit("SET_UNIQUEID",data.unique_id);
                  _this.uniqueId = data.unique_id;
                  //获取account_id
                  CP.getAccountId({
                    completed: function(data){
                      console.log('data.account_id',data.account_id);
                      _this.$store.commit("SET_ACCOUNTID",data.account_id);
                      _this.accountId = data.account_id;
                      // _this.loginInit(data);
                    },
                    cpIncompatible: function () {
                      CP.tools.writelog('CP.getAccountId', '此环境不支持此方法');
                    }
                  });
                },
                cpIncompatible: function () {
                  CP.tools.writelog('CP.getUniqueId', '此环境不支持此方法');
                }
              });
            } else {
              //调用用户登录窗口
              CP.showLogin({
                completed: function(data){
                  if(data.is_login==1) {
                    console.log(data.account_id);
                    _this.$store.commit("SET_UNIQUEID",data.unique_id);
                    _this.$store.commit("SET_ACCOUNTID",data.account_id);
                    _this.uniqueId = data.unique_id;
                    _this.accountId = data.account_id;
                    // _this.loginInit(data);
                  }
                  CP.tools.writelog('show_login', data);
                },
                cpIncompatible: function () {
                  CP.tools.writelog('CP.showLogin', '此环境不支持此方法');
                }
              });
            }   
          },
          cpIncompatible: function () {
            CP.tools.writelog('CP.isLogin', '此环境不支持此方法');
          }
          });
      }

      if(runAll) {
        let zjrbCp = document.createElement('script');
        zjrbCp.async = "async";
        zjrbCp.src = 'https://cdn-cp.tmuyun.com/jssdk/v1/zjrb-cp.v1.min.js';
        zjrbCp.charset = "UTF-8";
        document.body.appendChild(zjrbCp);     
        
        localStorage.setItem('hbrb_account_id', '');
        localStorage.setItem('hbrb_unique_id', '');

        zjrbCp.onload = function(){
          if(CP && typeof CP.ready === 'function'){
              console.log("CP准备就绪");
              CP.ready({
                debug:false,  //可选，是否是开启调试模式, 默认false
                es6Require: false, //可选，是否需要加载es6库，默认false
                ready:function(client_info){
                  //jssdk加载完成调用此方法
                  console.log('业务逻辑初始化开始0');
                  cpMain();// 业务逻辑初始化的main函数
                },
                error: function (error) {
                  console.log('出现错误',error);
                }
              });
          }
        }
      } else {
        cpMain();// 业务逻辑初始化的main函数
      }       
    },
    async actInit(){
      let result = await reqInit({learnid:this.learnid});
      if(result.flag=='success') {
        this.actInfo = result.data;
        this.$store.commit("SET_ACTINFO",result.data); 
        if(result.data.status==0) {
          this.$toast({
            icon: 'warning-o',
            message: "活动尚未开始"
          });
        } else if(result.data.status==2) {
          this.$toast({
            icon: 'warning-o',
            message: "活动已结束"
          });
        }
        this.style = result.data.style;
        this.title = result.data.title;
        this.shareImg = result.data.share_img;
        this.shareTitle = result.data.share_title;
        this.shareDesc = result.data.share_desc;

        //分享设置
        wxShare({
          title: this.shareTitle,
          desc: this.shareDesc,
          img: this.shareImg
        })
      } else {
        this.$toast({
          icon: 'warning-o',
          message: result.message
        });
      }
    },
    async noticeBox(){
      let result = await reqExplain({learnid:this.learnid});
      if(result.flag=='success') {
        this.explain = result.data.explain;   
      }
      this.showNotice = true;
    },
    async isReg(){
      let result = await reqIsReg({learnid:this.learnid,hbrb_account_id:this.accountId,hbrb_unique_id:this.uniqueId});
      if(result.flag=='success'){
        let markField = localStorage.getItem(this.learnid+'_markField');
        if(markField==result.markField){ //当前用户有登录记录
          localStorage.setItem(this.learnid+'_markField', result.markField);
        } else {
          Cookies.set('ckplayer-player-cookie','') //当前用户没登录记录，则清空观看信息
          localStorage.setItem(this.learnid+'_markField', result.markField);
        }

        localStorage.setItem(this.learnid+'_viewed', result.viewed);        
        
        this.$router.push({ path: '/list',query:this.$route.query })  //直接进入课程列表页
      }else{
        // this.$toast({
        //   icon: 'warning-o',
        //   message: result.message
        // });
        localStorage.setItem(this.learnid+'_viewed', '');
        console.log('to reg');
        this.$router.push({ path: '/reg',query:this.$route.query })  //进入信息登记页
      }
    },
    toReg(){
      if(this.actInfo.status==0) {
        this.$toast({
          icon: 'warning-o',
          message: "活动尚未开始"
        });
        return false;
      } else if(this.actInfo.status==2) {
        this.$toast({
          icon: 'warning-o',
          message: "活动已结束"
        });
        return false;
      }
      let _this = this; 
      if(this.accountId && this.uniqueId) {
        this.isReg()
      } else {
        Dialog.confirm({
          title: '消息提示',
          message: '请登录客户端后参与活动',
        })
          .then(() => {
            if (/(hbxw)/i.test(navigator.userAgent)) {
              _this.cpLoad(false);
            } else {
              _this.$refs.child.toLink();
            }
          })
          .catch(() => {
            // on cancel
          });
      }    
    },
    openApp(){
      jump2zonglan.toMLink()
    },    
    toHome(){
      this.$router.push({ path: '/index',query:this.$route.query })
    },
    toMyCenter(){
      this.$router.push({ path: '/mycenter',query:this.$route.query })
    },
    toExam(){
      window.location.href="https://huodong.wes2.com/hudong/dati/155/app.html";
    }
  }
  
}
</script>
<style>
@media screen and (min-width: 1200px) {
  html,body { 
    display: flex; 
    justify-content: center; 
    font-size: 200px!important;
  }
}
</style>
<style lang="scss" scoped>
.page{
  width: 750px;
  min-height: 100vh;
  background: var(--styleColor);
  .topBanner{
    width: 750px;
    height: auto;
    img{
      width: 100%;
      height: auto;
    }
  }
  .titleDown {
      animation: bounceInDown .5s ease 1;
      -webkit-animation: bounceInDown .5s ease 1
  }
  @keyframes bounceInDown {
      0% {
          opacity: 0;
          -webkit-transform: translateY(-2000px)
      }

      60% {
          opacity: 1;
          -webkit-transform: translateY(30px)
      }

      80% {
          -webkit-transform: translateY(-10px)
      }

      100% {
          -webkit-transform: translateY(0)
      }
  }
  .startTada {
      animation: tada .6s ease 0s 1 forwards;
      -webkit-animation: tada .6s ease 0s 1 forwards
  }
  @keyframes tada {
        0% {
            transform: scale3d(1,1,1)
        }

        10%,20% {
            transform: scale3d(.9,.9,.9) rotate3d(0,0,1,-3deg)
        }

        30%,50%,70%,90% {
            transform: scale3d(1.1,1.1,1.1) rotate3d(0,0,1,3deg)
        }

        40%,60%,80% {
            transform: scale3d(1.1,1.1,1.1) rotate3d(0,0,1,-3deg)
        }

        100% {
            transform: scale3d(1,1,1)
        }
    }


  .btnBox{
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
    .learn,.rule,.exam{
      width: 300px;
      height: auto;
      img{
        width: 100%;
        height: auto;
      }
    }

  }
  .navBox{
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 750px;
    height: 100px;
    background: #f9f9f9;
    border-top: 1px solid #c8c8c8;
    display: flex;
    justify-content: space-evenly;
    font-size: 30px;
    .navTxt{
      padding:0px 50px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #808080;
      font-weight: 400;
      i{
        font-size: 40px;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        // color:#808080
      }
    }
  } 
  .note{
    // width: 150px;
    padding: 0px 20px;
    padding-right: 15px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #808080b2;
    color: #fff;
    border: 1px solid #ddd;
    border-right: 0px;
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
    font-size: 28px;
    position: absolute;
    right: 0px;
    top: 200px;
  }
  //培训规则
  .noticBox{ width: 100%; height: auto; font-size: 30px; padding-bottom: 80px; overflow: hidden;}
  .noticTitle{ display: block; width: 100%; height: 30px; margin-top: 80px; font-size: 34px; display: flex; align-items: center; justify-content: center;}
  .noticTxt{ width: 670; height: auto;  padding:0px 40px; margin-bottom: 30px; overflow: hidden; overflow-y: auto;}
  .noticTxt p{ padding: 0; margin: 15px 0px; width: 100%; text-indent: 2em; text-align: justify;}
  .noticBox .text{ padding: 0px 30px; color:var(--styleColor);}
  .noticBox .line{ border-top: 1px solid var(--styleColor); width: 130px; }
}

</style>